<template>
  <div class="auth-login__field">
    <label :for="id" class="auth-login__label">{{ label }}</label>

    <select
      :id="id"
      :name="name || undefined"
      class="auth-login__select"
      :class="{ 'auth-login__input--error': error }"
      :value="modelValue"
      :required="required"
      :aria-invalid="error ? 'true' : undefined"
      :aria-describedby="describedBy || undefined"
      @change="emit('update:modelValue', $event.target.value)"
    >
      <option value="" disabled>{{ placeholder }}</option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>

    <span v-if="hint && !error" :id="`${id}-hint`" class="auth-login__hint">{{ hint }}</span>
    <span v-if="error" :id="`${id}-error`" class="auth-login__error" role="alert">{{ error }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  id:           { type: String, required: true },
  name:         { type: String, default: '' },
  modelValue:   { type: String, default: '' },
  label:        { type: String, required: true },
  placeholder:  { type: String, default: 'Select an option' },
  options:      { type: Array, default: () => [] },
  hint:         { type: String, default: '' },
  error:        { type: String, default: '' },
  required:     { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue'])

const describedBy = computed(() => {
  if (props.error) return `${props.id}-error`
  if (props.hint) return `${props.id}-hint`
  return ''
})
</script>
